export default __webpack_public_path__ + "static/microsoft_logo-3c2332ca083c8cd89dd707b8c2a4127a.svg";